var EHDI = EHDI || Object.create(null);

EHDI.SoundManager = function (isAddInterrupt) {
    var _bgm = null;
    var _sfx = [];
    var _vo = null;
    var _muted  = false;
    var _isActive = true;
    var _isAutoResume = true;
	var _volume = { bgm: 1, sfx: 1, vo: 1 };
	var _hasInterrupt = isAddInterrupt || true;

    var pauseAll = function() {
        if(_bgm) {
            _bgm.paused = true;
        }
        _sfx.forEach(function (sfxElement) {
            sfxElement.paused = true;
        });
        if(_vo) {
            _vo.paused = true;
        }
    }

    var resumeAll = function() {
        if(!_isAutoResume)
            return;
        if(_bgm) {
            _bgm.paused = false;
        }
        _sfx.forEach(function (sfxElement) {
            sfxElement.paused = false;
        });
        if(_vo) {
            _vo.paused = false;
        }
    }

    var checkInterrupt = function() {
        if (window.document.webkitHidden || window.document.hidden) {
            pauseAll();
        } else {
            resumeAll();
        }
    }

    var addInterruptListener = function(){
		window.addEventListener("blur", pauseAll);
        window.addEventListener("focus", resumeAll);
        window.addEventListener("pagehide", pauseAll);
        window.addEventListener("pageshow", resumeAll);
        window.addEventListener("webkitvisibilitychange", checkInterrupt);
        window.addEventListener("webkitvisibilitychange", checkInterrupt);
	}

	var removeInterruptListener = function(){
		window.removeEventListener("blur", pauseAll);
        window.removeEventListener("focus", resumeAll);
        window.removeEventListener("pagehide", pauseAll);
        window.removeEventListener("pageshow", resumeAll);
        window.removeEventListener("webkitvisibilitychange", checkInterrupt);
        window.removeEventListener("webkitvisibilitychange", checkInterrupt);
	}

	if(_hasInterrupt) {
		addInterruptListener();
    }

    return {

		set enableInterrupt(v){
			if(typeof v !== "boolean" || _hasInterrupt === v) return;
			_hasInterrupt = v;
			if(_hasInterrupt){
				addInterruptListener();
			}else{
				removeInterruptListener();
			}
		},

		get enableInterrupt(){
			return _hasInterrupt;
		},

		set sfxVolume(v){
			if(typeof v !== "number") return;
			_volume.sfx = v;
			if(_sfx){
				_sfx.forEach(
					function(sfxElement) {
						sfxElement.volume = sfxElement.volume * _volume.sfx;
					} );
			}
		},

		get sfxVolume(){
			return _volume.sfx;
		},

		set bgmVolume(v){
			if(typeof v !== "number") return;
			_volume.bgm = v;

			if(_bgm) _bgm.volume = _bgm.volume * _volume.bgm;
		},

		get bgmVolume(){
			return _volume.bgm;
		},

		set voVolume(v){
			if(typeof v !== "number") return;
			_volume.vo = v;

			if(_vo) _vo.volume = _vo.volume * _volume.vo;
		},

		get voVolume(){
			return _volume.vo;
		},

        playBGM : function(bgmToPlay, volume) {
			volume = ( volume * _volume.bgm ) || _volume.bgm;
            if(typeof bgmToPlay === 'string') {
                if(_bgm instanceof createjs.AbstractSoundInstance) {
                    _bgm.stop();
                    _bgm.destroy();
                }
                _bgm = createjs.Sound.play(bgmToPlay, {loop : -1});
                _bgm.volume = volume;
                _bgm.muted = _muted;
                return _bgm;
            } else {
                throw("pass string id of BGM to be played");
            }
        },

        stopBGM : function () {
            if(_bgm) {
                _bgm.stop();
                _bgm.destroy();
				_bgm = null;
            }
        },

        pauseBGM : function () {
            if(_bgm) {
                _bgm.paused = true;
            }
        },

        resumeBGM : function () {
            if(_bgm) {
              _bgm.paused = false;
            }
        },

        playSFX : function(sfxToPlay, volume) {
			volume = ( volume * _volume.sfx ) || _volume.sfx;
            if(typeof sfxToPlay === 'string') {
                var playingSFX = createjs.Sound.play(sfxToPlay);
                playingSFX.volume = volume;
                playingSFX.muted = _muted;
                _sfx.push(playingSFX);
                var sfxListener = playingSFX.on("complete", function(sfxToStop) {
                    var index = _sfx.indexOf(sfxToStop.currentTarget);
                    if(index > -1) {
                        var forDisposal = _sfx.splice(index, 1)[0];
						playingSFX.off("complete", sfxListener);
                        forDisposal.destroy();
                    }
                });
                return playingSFX;
            } else {
                throw("pass string id of SFX to be played");
            }
        },

        stopSFX : function (sfxToStop) {
            var index = _sfx.indexOf(sfxToStop);
			if(index > -1) {
                var forDisposal = _sfx.splice(index, 1)[0];
                forDisposal.stop();
                forDisposal.destroy();
            }
        },

        stopAllSFX : function () {
            _sfx.forEach(function (sfxElement) {
                sfxElement.stop();
                sfxElement.destroy();
            });
            _sfx = [];
        },

        pauseAllSFX : function() {
            _sfx.forEach(function (sfxElement) {
                sfxElement.paused = true;
            });
        },

        resumeAllSFX : function() {
            _sfx.forEach(function (sfxElement) {
                sfxElement.paused = false;
            });
        },

        playVO : function(VOToPlay, volume) {
            volume = ( volume * _volume.vo ) || _volume.vo;
			if(typeof VOToPlay === 'string') {
                _vo = createjs.Sound.play(VOToPlay);
                _vo.volume = volume;
                _vo.muted = _muted;
                return _vo;
            } else {
                throw("pass string ID of VO to be played");
            }
        },

        stopVO : function() {
            if(_vo) {
                _vo.stop();
                _vo.destroy();
            }
        },

        pauseVO : function() {
            if(_vo) {
                _vo.paused = true;
            }
        },

        resumeVO : function() {
            if(_vo) {
                _vo.paused = false;
            }
        },

        setMute : function() {
            var isMute = arguments.length <= 0 || typeof arguments[0] === "undefined" ? !_muted : arguments[0];;
            _muted = isMute;
            if(_bgm)
                _bgm.muted = _muted;
            _sfx.forEach(function(sfxElement) {
               sfxElement.muted = _muted;
            });
            if(_vo)
                _vo.muted = _muted;
        },

		getMuted : function() {
            return _muted;
        },

        setDeactivate : function() {
            var isDeactivate = arguments.length <= 0 || typeof arguments[0] === "undefined" ? !_isActive : arguments[0];;
            _isActive = isDeactivate;
            if(_bgm)
                _bgm.paused = !_isActive;
            _sfx.forEach(function(sfxElement) {
               sfxElement.paused = !_isActive;
            });
            if(_vo)
                _vo.muted = !_isActive;
        },

        autoResumeToggle : function(isAutoResume) {
            _isAutoResume = isAutoResume;
        }
    };
};
